import axios from "axios";
import Cookies from "js-cookie";
import { apiRoutesForContext } from "src/routes/apiRoutes/react-api-route-paths";
import { ApproveRegistrationUser, Users } from "src/sdk";
import { PaginationRequest } from './../sdk/models/SuperAdminModules';
import { BaseService } from "./BaseService";

const tmp = apiRoutesForContext();
export class SuperAdminService extends BaseService {
    public authRoutes: typeof tmp;

    constructor() {
        super();
        this.authRoutes = apiRoutesForContext();
    }


    /* UsersManagment */
    createUser(data: Users): Promise<any> {
        var token = Cookies.get("JwtToken");
        return axios({
            method: "post",
            baseURL: this.routes.server.root(),
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
            url: this.routes.superAdmin().createUser(),
            data: data
        })
    }

    getUsers(data: PaginationRequest): Promise<any> {
        var token = Cookies.get("JwtToken");
        return axios({
            method: "get",
            baseURL: this.routes.server.root(),
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
            url: this.routes.superAdmin().getUsers() + "?pageSize=" + data.pageSize + "&page=" + data.page + "&search=" + data.search + "&sortBy=" + data.sortBy + "&sortOrder=" + data.sortOrder,
        })
    }

    getUsersByOrganisationId(data: PaginationRequest): Promise<any> {
        var token = Cookies.get("JwtToken");
        return axios({
            method: "get",
            baseURL: this.routes.server.root(),
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
            url: this.routes.superAdmin().getUsersByOrganisationId() + "/" + data.organisationId + "?pageSize=" + data.pageSize + "&page=" + data.page + "&search=" + data.search + "&sortBy=" + data.sortBy + "&sortOrder=" + data.sortOrder,
        })
    }

    editUser(data: Users): Promise<any> {
        var token = Cookies.get("JwtToken");
        return axios({
            method: "put",
            baseURL: this.routes.server.root(),
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
            url: this.routes.superAdmin().editUser() + "/" + data.userId,
            data: data
        })
    }

    deleteUser(userId: string): Promise<any> {
        var token = Cookies.get("JwtToken");
        return axios({
            method: "delete",
            baseURL: this.routes.server.root(),
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
            url: this.routes.superAdmin().deleteUser() + "/" + userId,
        })
    }

    approveRegistrationUser(data: ApproveRegistrationUser): Promise<any> {
        var token = Cookies.get("JwtToken");
        return axios({
            method: "post",
            baseURL: this.routes.server.root(),
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
            url: this.routes.superAdmin().approveRegistrationUser(),
            data: data
        })
    }

    asignUserRole(data: Users): Promise<any> {
        var token = Cookies.get("JwtToken");
        console.log(data)
        return axios({
            method: "put",
            baseURL: this.routes.server.root(),
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
            url: this.routes.superAdmin().asignUserRole() + "/users/" + data.userId + "/administrator?isAdmin=" + data.isAdmin,
        })
    }

}
